function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "download",
  transform: "translate(-20853 -1564)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2342",
  "data-name": "Rectangle 2342",
  transform: "translate(20853 1564)",
  fill: "#fff",
  stroke: "#a7afb9",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 26,
  rx: 4,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 27,
  height: 25,
  rx: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "download-2",
  "data-name": "download",
  transform: "translate(20857 1566.7)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1368",
  "data-name": "Path 1368",
  d: "M17,15v3.178a1.572,1.572,0,0,1-1.556,1.589H4.556A1.572,1.572,0,0,1,3,18.178V15",
  transform: "translate(0 -2.467)",
  fill: "none",
  stroke: "#a7afb9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1369",
  "data-name": "Path 1369",
  d: "M7,10l3.822,3.972L14.644,10",
  transform: "translate(-0.822 -1.439)",
  fill: "none",
  stroke: "#a7afb9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_6",
  "data-name": "Line 6",
  y1: 9,
  transform: "translate(9.853 3.3)",
  fill: "none",
  stroke: "#a7afb9",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})));

var SvgDownloadResourceDisabled = function SvgDownloadResourceDisabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadResourceDisabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download_resource_disabled.8f88eacb.svg";
export { ForwardRef as ReactComponent };